import React from 'react';
import PropTypes from 'prop-types';

const SelectField = props => {
  const { field, renderFields } = props;
  const { caption, items } = field;

  return (
    <div key={caption} className="d-flex flex-column justify-content-center">
      <label htmlFor="name" className="field-label text-center">
        {caption}
      </label>
      <div className="d-flex align-items-center justify-content-center">
        {renderFields(items)}
      </div>
    </div>
  );
};

SelectField.propTypes = {
  field: PropTypes.object.isRequired,
  renderFields: PropTypes.func.isRequired,
};

export default SelectField;
